import script from "./MessageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageDetail.vue?vue&type=script&setup=true&lang=js"

import "./MessageDetail.vue?vue&type=style&index=0&id=ca8571da&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca8571da"]])

export default __exports__